import { NewPatientsPage } from "~/components/new-patients/NewPatientsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/new-patients")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/new-patients"),
  component: NewPatientsPage,
});
